module.exports = __webpack_public_path__ + "img/id-verified.747772ef.jpg";